import {
  setPDPCustomisationLoad,
  setOrgPDPCustomisation,
} from "@redux/slices/appStateSlice";
import { setPdpLayout } from "@redux/slices/pdpLayoutSlice";
import { ThemeTokenTypes } from "@scenes/splash-screen/types";
import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { useDispatch } from "react-redux";

export const usePdpLayoutData = (
  url: string,
  enabled?: boolean,
  type?: string
) => {
  const dispatch = useDispatch();
  const timestamp = Date.now();

  return useQuery({
    queryKey: ["GET_PDP_LAYOUT_DATA"],
    enabled: enabled,
    queryFn: () =>
      axios.get(url + "?timestamp=" + timestamp).then((data) => {
        if (type === ThemeTokenTypes.ORG) {
          dispatch(setOrgPDPCustomisation(data.data));
        }
        if (type === ThemeTokenTypes.COMPANY) {
          dispatch(setPDPCustomisationLoad(true));
        }
        dispatch(setPdpLayout(data.data));
        return data;
      }),
    onError: (err) => {
      console.log("err", err);
    },
  });
};
